export enum SelectionOptionsEnum {
  colors = 'colors',
  products = 'products',
  profiles = 'profiles',
  splashes = 'splashes',
  thicknesses = 'thicknesses',
  installer_crews = 'installer_crews',
}
